import tcl from "refractor/tcl";
export default tcl;